'use strict';
import * as $j_com$002eraquo$002eairstream$002esplit$002e$002dDuplicate$002dKeys$002dConfig from "./com.raquo.airstream.split.-Duplicate-Keys-Config.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
  this.EC = null;
  $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = this;
  this.EC = new $j_com$002eraquo$002eairstream$002esplit$002e$002dDuplicate$002dKeys$002dConfig.$c_Lcom_raquo_airstream_split_DuplicateKeysConfig(false);
}
export { $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
$p = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
/** @constructor */
function $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
}
export { $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $h_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
$h_Lcom_raquo_airstream_split_DuplicateKeysConfig$.prototype = $p;
var $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_DuplicateKeysConfig$, "com.raquo.airstream.split.DuplicateKeysConfig$", ({
  h8: 1
}));
export { $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $d_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
var $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
function $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$() {
  if ((!$n_Lcom_raquo_airstream_split_DuplicateKeysConfig$)) {
    $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$ = new $c_Lcom_raquo_airstream_split_DuplicateKeysConfig$();
  }
  return $n_Lcom_raquo_airstream_split_DuplicateKeysConfig$;
}
export { $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$ as $m_Lcom_raquo_airstream_split_DuplicateKeysConfig$ };
